import React from 'react';
import { Orientation } from 'shared/constants/Export';

export default React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    return <div ref={this._handleRefZoom}>{this.props.children}</div>;
  },

  _handleRefZoom(el) {
    let {
      location,
      params: { type },
    } = this.context.router.state;

    let { disableResizing } = this.props;

    if (!el || (disableResizing && !type)) return;

    let tableWidth = el.scrollWidth;
    let zoom = 1;

    if (
      !location ||
      !location.query ||
      location.query.orientation === Orientation.portrait
    ) {
      //Orientation Portrait
      if (tableWidth > 1152) zoom = 0.9; //up to 8 cols
      if (tableWidth > 1233) zoom = 0.8; //up to 10 cols
      if (tableWidth > 1403) zoom = 0.7; //up to 13 cols
      if (tableWidth > 1658) zoom = 0.6; //up to 16 cols
      if (tableWidth > 1913) zoom = 0.5; //up to 21 cols
      if (tableWidth > 2338) zoom = 0.4; //up to 28 cols
      if (tableWidth > 2933) zoom = 0.3;
    } else {
      //Orientation: Landscape
      if (tableWidth > 1670) zoom = 0.78;
      if (tableWidth > 1840) zoom = 0.68;
      if (tableWidth > 2090) zoom = 0.58;
      if (tableWidth > 2430) zoom = 0.48;
      if (tableWidth > 2700) zoom = 0.38;
      if (tableWidth > 3360) zoom = 0.28;
    }

    el.style.zoom = zoom;
  },
});
